import { render } from "./ordenTrabajo.vue?vue&type=template&id=5d42cbb5&scoped=true"
import script from "./ordenTrabajo.vue?vue&type=script&lang=js"
export * from "./ordenTrabajo.vue?vue&type=script&lang=js"

import "./ordenTrabajo.vue?vue&type=style&index=0&id=5d42cbb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d42cbb5"]])

export default __exports__